const isSameOrigin = (url: string) => {
	try {
		const target = new URL(url, window.location.href)
		return target.origin === window.location.origin
	} catch {
		return false
	}
}

const getOverlay = () => document.getElementById("page-transition-overlay") as HTMLDivElement | null

const showOverlay = (overlay: HTMLDivElement) => {
	overlay.style.pointerEvents = "auto"
	overlay.style.opacity = "1"
}
const hideOverlay = (overlay: HTMLDivElement) => {
	overlay.style.opacity = "0"
	window.setTimeout(() => (overlay.style.pointerEvents = "none"), 250)
}

const overlay = getOverlay()

window.addEventListener("pageshow", () => {
	if (overlay) hideOverlay(overlay)
})

document.addEventListener("click", e => {
	const target = e.target as HTMLElement | null
	if (!target) return
	const anchor = target.closest("a") as HTMLAnchorElement | null
	if (!anchor) return
	const href = anchor.getAttribute("href")
	if (!href) return
	if (anchor.target === "_blank") return
	if (anchor.hasAttribute("download")) return
	if (href.startsWith("#")) return
	if (!isSameOrigin(href)) return
	if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
	if (!overlay) return
	e.preventDefault()
	showOverlay(overlay)
	window.setTimeout(() => {
		window.location.href = href
	}, 250)
})

window.addEventListener("beforeunload", () => {
	if (overlay) showOverlay(overlay)
})
//
